const getEnvironment = (): 'prod' | 'test' | null => {
  if (
    window.location.hostname.includes('prod.netflixstudios.com') ||
    (window.location.hostname.includes('.netflixstudios.com') &&
      !window.location.hostname.includes('test.netflixstudios.com') &&
      !window.location.hostname.includes('test.cloud.netflix.net'))
  ) {
    return 'prod';
  } else if (
    window.location.hostname.includes('localhost') ||
    window.location.hostname.includes('test.cloud.netflix.net')
  ) {
    return 'test';
  }
  return null;
};

export const isTest = (): boolean => getEnvironment() === 'test';
